import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonViewWithBadge} from './UIGameActionButtonViewWithBadge'
import {PIXI} from '@colonist/pixi'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {ActionsThatCanBeCancelled, PieceTypes} from '@colonist/game-base-types'
import {UIGameActionButtonView} from './UIGameActionButtonView'
import {getCardsForPiece} from '@colonist/game-card-types'
import {ActionState, TileCornerBuildingType, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'
import {ArrayUtils} from '@colonist/utils'

export class UIGameActionButtonViewKnightPlacement extends UIGameActionButtonViewWithBadge {
    private readonly parentButton: UIGameActionButtonView
    private readonly knightPlayerValidator: MechanicValidatorKnightPlayer

    constructor(uiGameManager: UIGameManager, container: PIXI.Container, parentButton: UIGameActionButtonView, knightPlayerValidator: MechanicValidatorKnightPlayer) {
        const knightToShow = TileCornerBuildingType.KnightInactiveLevel1
        const texture = UIGameSpriteHandler.getKnightForPlayer(uiGameManager.gameController.myColor, knightToShow)
        const amountOfLevel1KnightsThatCanBePlaced = knightPlayerValidator.getAmountOfKnightsOfLevelThatCanBePlacedOnMap(1)
        const preferredPosition = 1
        super(uiGameManager, preferredPosition, container, amountOfLevel1KnightsThatCanBePlaced)
        this.addCenteredIcon(texture)
        this.parentButton = parentButton
        this.knightPlayerValidator = knightPlayerValidator

        this.setUpdateAction()
        this.stateUpdated()
        const cardsToBuildKnight = getCardsForPiece(PieceTypes.Knight)
        this.setHoverAction(cardsToBuildKnight)
        this.setTip({key: 'strings:game.tooltips.purchaseKnight'}, [{key: 'strings:colonistCommon.utils.emptyString'}])
    }

    buttonSpecificEvents(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.KnightStateUpdated:
                this.stateUpdated()
                this.playerStateUpdated()
                break
            case UIGameEventEnums.GameStateUpdated: this.stateUpdated(); break
            case UIGameEventEnums.ShowTradeUI: this.cancelBuild(); break
            default: break
        }
    }

    protected playerStateUpdated() {
        const amountOfLevel1KnightsThatCanBePlaced = this.knightPlayerValidator.getAmountOfKnightsOfLevelThatCanBePlacedOnMap(1)
        this.updateBadgeCount(amountOfLevel1KnightsThatCanBePlaced)
    }

    private setUpdateAction() {
        this.updateAction(() => {
            this.clickedKnightButton()
        })
    }

    private clickedKnightButton() {
        if(this.cancelBuild()) return

        const useResources = true
        const canPlayerPlaceKnight = this.knightPlayerValidator.canPlayerPlaceNewKnight(useResources)
        if(!this.canPerformBuyAction(canPlayerPlaceKnight)) return

        this.uiGameManager.socketGameSend.placeKnight()
    }

    private cancelBuild(): boolean {
        if(!this.uiGameManager.gameController.isMyTurn) return false
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.PlaceKnight) return false

        this.uiGameManager.eventController.sendEvent([], UIGameEventEnums.SetCornerHighlight)
        this.uiGameManager.socketGameSend.cancelAction()
        return true
    }

    protected stateUpdated() {
        this.inactivateOpacity()
        this.removeHighlight()

        if(!this.uiGameManager.gameController.isMyTurn) return
        if(!this.canPlayerPlaceLevel1Knight()) return

        this.updateOpacityForTurnState()
        this.updateHighlightForActionState()
    }

    private canPlayerPlaceLevel1Knight(): boolean {
        const useResources = true
        const canPlayerPlaceKnight = this.knightPlayerValidator.canPlayerPlaceNewKnight(useResources)
        // console.log('can player place knight', canPlayerPlaceKnight)
        return canPlayerPlaceKnight.canTakeAction
    }

    private updateOpacityForTurnState() {
        if(!this.allowableTurnStates()) return
        if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, this.uiGameManager.gameController.currentState.actionState)) return
        this.activateOpacity()
        this.parentButton.activateOpacity()
    }

    private allowableTurnStates(): boolean {
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.Turn) return true
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase) return true

        return false
    }

    private updateHighlightForActionState() {
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.PlaceKnight) return
        this.activateOpacity()
        this.highlight()
    }
}
